module.exports = __webpack_public_path__ + "static/media/icon_image_b.e4fed388.svg";